/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Price/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Price({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Charges/Content/Content/Charge/Price"
  
}) {
let chargePriceValueData = fromData.useDataFormat({ viewPath,
context: 'charge',
path: 'price',
format: fromFormat.numberMoney,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="charge.price"
 format="/Data/format.js numberMoney"
 text={chargePriceValueData}
 size="small"
/>
{children}
</React.Fragment>)
}